import * as React from 'react';
import { Col, Row, Button, Radio, Icon, Spin, Form, notification } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next'
import autobind from 'autobind-decorator';
import { WhatsNewReportItem, WhatsNewReportStore } from '../../../../stores/whats-new-store'
import WhatsNewReportForm from './whats-new-report-form'
import { connect } from 'redux-scaffolding-ts';
import { FormComponentProps } from 'antd/lib/form';
import { IdentityProps, withIdentity } from '../../../../core/services/authentication';
import {UserProfileProps, withUserProfile} from "../../../../components/user-profile";

interface WhatsNewReportViewProps {
    language: string;
}

interface WhatsNewReportViewState {
    isBusy: boolean
    item?: WhatsNewReportItem
}

@connect(['whatsNewReports', WhatsNewReportStore])
class WhatsNewReportEditView extends React.Component<WhatsNewReportViewProps & WithTranslation & FormComponentProps & UserProfileProps, WhatsNewReportViewState> {
    private get whatsNewReportsStore() {
        return (this.props as any).whatsNewReports as WhatsNewReportStore;
    }

    constructor(props: WhatsNewReportViewProps & WithTranslation & FormComponentProps & UserProfileProps) {
        super(props);
        this.state = {
            isBusy: false
        }
    }

    componentDidMount() {
        this.load()
    }

    @autobind
    private async load() {
        this.setState({ isBusy: true })
        this.whatsNewReportsStore.getByLanguage(this.props.language).then((result) => {
            this.props.form.resetFields()   
            this.setState({ isBusy: false, item: result })
        }).catch(() => {
            this.setState({ isBusy: false })
        })
    }

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async onSaveItem() {
        this.setState({ isBusy: true })
        var self = this;
        const { t } = this.props;
        await new Promise<void>((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event && self.state.item) {
                    values = { ...values, language: self.props.language, id: self.state.item.id }
                    self.whatsNewReportsStore.update(values as WhatsNewReportItem).then(result => {
                        if (result.isSuccess) {
                            resolve();
                            this.setState({ isBusy: false });
                            self.countDownNotification(notification.success, t('Success'), t("News Report successfully added"), 'success')
                        } else {
                            reject();
                            this.setState({ isBusy: false });
                            self.countDownNotification(notification.error, t('Error'), t("There was an error"), 'fail')
                        }
                    });
                } else {
                    this.setState({ isBusy: false });
                    let message: string = event.text ? "Insert text for Users" : "Insert text for Managers";
                    self.countDownNotification(notification.info, t('Info'), t(message), 'fail')
                }            
            });
        })
    }

    public render() {
        const { t } = this.props
        let isReadOnly = this.isReadOnly()
        return (
            <Spin spinning={this.state.isBusy}>
                <Row>
                    <Col span={24}>
                        <Form
                            form={this.props.form}
                            onSubmit={this.onSaveItem} >
                            <WhatsNewReportForm
                                item={this.state.item}
                                getFieldDecorator={this.props.form.getFieldDecorator}
                                onSave={this.onSaveItem}
                            />
                        </Form>
                    </Col>
                </Row>
                <Row style={{ marginTop: 5 }}>
                    <Button disabled={this.isReadOnly()} style={{ float: 'right', margin: 3 }} type="primary" onClick={this.onSaveItem} > {t("Save")} </Button>
                    <Button disabled={this.isReadOnly()} style={{ float: 'right', margin: 3 }} onClick={() => this.load()} > {t("Cancel")} </Button>
                </Row>
            </Spin>
        );
    }
}
export default withUserProfile(withTranslation()(withIdentity((Form.create({})(WhatsNewReportEditView) as any) as any))) as any as React.ComponentClass<WhatsNewReportViewProps>;